/**
 * Created by Daniel on 09/04/2019.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Component, OnInit, AfterViewInit } from '@angular/core';
import { CalendarScreenConfig } from '../../../../components/calendar-screen/calendar-screen.model';
import { Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { lastCustomActionSelector } from '../../../../redux/reducers/action-history.reducer';
import { CalendarEventsActionTypes } from '../../../../redux/actions/calendar.action';
import { CalendarSubChromeConfig } from '../../../../components/calendar-screen/calendar-sub-chrome/calendar-sub-chrome.model';
import { ActivatedRoute } from '@angular/router';
import { businessConstants } from '../../../../tamalelibs/constants/business.constants';
import { ScreenActionTypes } from '../../../../redux/actions/screen.actions';
import { RELOAD_CALENDARS_SUCCESS } from '../../../../tamalelibs/redux/calendar-list.actions';

@Component({
    selector: 'calendar-wrapper',
    templateUrl: './calendar-wrapper.component.html',
    styleUrls: ['./calendar-wrapper.component.scss']
})
export class CalendarWrapperComponent implements OnInit, AfterViewInit {
    calendarScreenConfig: CalendarScreenConfig;
    calendarSubChromeConfig: CalendarSubChromeConfig;
    isPageLoading = true;

    private _destroySubscriptions: Array<Subscription> = [];
    private _route: ActivatedRoute;

    constructor(private _store: Store<any>) { }

    ngOnInit() {
        this.isPageLoading = true;
        this._initCalendarPage();

        this._destroySubscriptions.push(
            this._store.pipe(
                select(lastCustomActionSelector)
            ).subscribe(action => this._actionMessageHandler(action))
        );
    }

    ngAfterViewInit() {
        this._triggerDataLoad();
    }

    private _actionMessageHandler(action) {
        if (action.type === CalendarEventsActionTypes.RELOAD_SUCCESS || action.type === RELOAD_CALENDARS_SUCCESS) {
            this.isPageLoading = false;
        }
    }

    private _initCalendarPage() {
        this.calendarScreenConfig = new CalendarScreenConfig(null, null);
        this.calendarSubChromeConfig = new CalendarSubChromeConfig();

        if (this._route) {
            const currentPageInfo: any = {
                url: this._route.snapshot.url,
                name: 'Calendar',
                type: 'CALENDAR',
                screenType: businessConstants.calendar.screenType
            };
            this._store.dispatch({
                type: ScreenActionTypes.SET_VALUE,
                payload: currentPageInfo
            });
        }
    }

    private _triggerDataLoad() {
        this.calendarScreenConfig.actions$.next({
            type: 'RELOAD'
        });
    }
}
